import { useQuery } from '@tanstack/react-query'

import { apiGetCoinBalance } from '@/apis/coins/getCoinBalance'

import { COIN_KEYS } from '../keys/coins'

export const useGetCoinBalance = () => {
  return useQuery({
    queryKey: [COIN_KEYS.BALANCE],
    queryFn: apiGetCoinBalance,
  })
}
